export default {
      id: "phone-usage",
      viewBox: "0 0 19.386 19.386",
      url: __webpack_public_path__ + "svg/sprite.svg#phone",
      toString: function () {
        return this.url;
      }
    }